import usersApi from '@/api/v1/users';

export default {
  namespaced: true,

  state: {
    dashboardData: [],
    isProcessing: false,
  },
  mutations: {
    SET_DASHBOARD_DATA(state, data) {
      state.dashboardData = data;
    },
    SET_DASHBOARD_PROCESSING(state, isProcessing) {
      state.isProcessing = isProcessing;
    },
  },

  actions: {
    fetchDashboardData({ commit, rootState }) {
      commit('SET_DASHBOARD_PROCESSING', true);
      const params = {
        filters: rootState.filters.selectedFilters,
      };

      usersApi.getDashboardData(params)
        .then((response) => {
          commit('SET_DASHBOARD_DATA', response.data);
        })
        .finally(() => {
          commit('SET_DASHBOARD_PROCESSING', false);
        });
    },
  },
};
